import { Union } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { list_type, union_type, array_type, class_type, string_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { createObj } from "../../fable_modules/fable-library-js.4.18.0/Util.js";
import { map } from "../../fable_modules/fable-library-js.4.18.0/List.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.18.0/Array.js";
import * as react from "react";
import { Menu as Menu_1 } from "antd";

export class MenuItemProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Key", "Label", "Icon", "Children", "ItemType"];
    }
}

export function MenuItemProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Menu.MenuItemProps", [], MenuItemProps, () => [[["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", array_type(MenuItem_$reflection())]], [["Item", string_type]]]);
}

export class MenuItem extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["MenuItem"];
    }
}

export function MenuItem_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Menu.MenuItem", [], MenuItem, () => [[["Item", list_type(MenuItemProps_$reflection())]]]);
}

export class MenuProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mode", "DefaultOpenKeys", "DefaultSelectedKeys", "ClassName", "Items"];
    }
}

export function MenuProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Menu.MenuProps", [], MenuProps, () => [[["Item", string_type]], [["Item", array_type(string_type)]], [["Item", array_type(string_type)]], [["Item", string_type]], [["Item", array_type(MenuItem_$reflection())]]]);
}

export function menuItemToObj(_arg) {
    return createObj(map((_arg_1) => {
        switch (_arg_1.tag) {
            case 1:
                return ["label", _arg_1.fields[0]];
            case 2:
                return ["icon", _arg_1.fields[0]];
            case 3:
                return ["children", map_1(menuItemToObj, _arg_1.fields[0])];
            case 4:
                return ["type", _arg_1.fields[0]];
            default:
                return ["key", _arg_1.fields[0]];
        }
    }, _arg.fields[0]));
}

export function Menu(props) {
    const propsObj = createObj(map((_arg) => {
        switch (_arg.tag) {
            case 1:
                return ["defaultOpenKeys", _arg.fields[0]];
            case 2:
                return ["defaultSelectedKeys", _arg.fields[0]];
            case 3:
                return ["className", _arg.fields[0]];
            case 4:
                return ["items", map_1(menuItemToObj, _arg.fields[0])];
            default:
                return ["mode", _arg.fields[0]];
        }
    }, props));
    return react.createElement(Menu_1, propsObj);
}

